export default function getResource(label, vars = []) {
    const resources = {
        autoReplenishTitle: `Auto-Replenish (${vars[0]})`,
        changeMethod: 'Change Method',
        qtyUpdateError: 'We couldn’t update qty. Please try again.',
        retry: 'Retry'
    };

    return resources[label];
}
